const RenderWeekHeader = (weekNumber, weeklyRanges) => {
    const range = weeklyRanges[weekNumber] || { start: "", end: "" };

    const month = range.start.split("-")[1]

    return (
        <th key={`W${weekNumber}`} className="border-right">
            <div className="hCol">
                <div>W{weekNumber} - {month}</div>
                <div className="font-extralight">{range.start.split("-")[0]} – {range.end.split("-")[0]}</div>
            </div>
        </th>
    );
};

export default RenderWeekHeader